import * as React from 'react';

import { CloseFullscreenMapButton } from '../../components/CloseFullscreenMapButton';
import { closeMap, useFragmentStoreContext } from '../../context';

export const CloseFullscreenMapButtonContainer: React.FC = () => {
  const {
    state: { isPanoramaOpen },
    dispatch,
  } = useFragmentStoreContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleCloseMap = React.useCallback(() => dispatch(closeMap()), []);

  if (isPanoramaOpen) {
    return null;
  }

  return <CloseFullscreenMapButton onClick={handleCloseMap} />;
};
